class PropertySearch {
    private searchStack: string[]
    private stackLimit: number

    constructor (data: string[] = []) {
        this.searchStack = data
        this.stackLimit = 3
    }

    add (params: string) {
        if (params.length > 0 && !this.find(params)) {
            if (this.searchStack.length === this.stackLimit) {
                this.remove()
            }
            this.searchStack.unshift(params)
        }
        return this.searchStack
    }

    private remove () {
        this.searchStack.pop()
    }

    private find (newSearchTerm: string) {
        return this.searchStack.find(item => newSearchTerm === item);
    }

}

export {
    PropertySearch
}